"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bytesToSize = void 0;
function bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes <= 0)
        return "0 Byte";
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
}
exports.bytesToSize = bytesToSize;
//# sourceMappingURL=bytesToSize.js.map